import { StaticJsonRpcProvider } from '@ethersproject/providers'

export const BSC_PROD_NODE = process.env.NEXT_PUBLIC_NODE_PRODUCTION || 'https://bsc-dataseed1.bnbchain.org'

export const bscRpcProvider = new StaticJsonRpcProvider(BSC_PROD_NODE)
export const goerliRpcProvider = new StaticJsonRpcProvider('https://data-seed-prebsc-2-s1.bnbchain.org:8545')

export default null
